import { batchActions } from 'redux-batched-actions';

import * as CommonMenu from '../actions/CommonMenu';
import apiUrls from '../apiUrls';
import { urls } from '../utils/routing';
import { fetchWithSpinner, fetchWrapper as fetch } from '../utils/fetch';
import { processNotifications, processUpdateAccessData } from '../utils/responseProcessing';
//import { multiDownload } from '../utils/functions';

export const START_FETCHING = 'CURRENT_ACCOUNT_START_FETCHING'
export const STOP_FETCHING = 'CURRENT_ACCOUNT_STOP_FETCHING'
export const SET_LANGUAGE = 'CURRENT_ACCOUNT_SET_LANGUAGE'
export const SET_IS_BANNED = 'SET_IS_BANNED'

export const START_LOGIN = 'START_LOGIN'
export const STOP_LOGIN = 'STOP_LOGIN'
export const SET_ERROR_LOGIN = 'SET_ERROR_LOGIN'
export const UPDATE_ACCOUNT = 'UPDATE_ACCOUNT'
export const UPDATE_SPA_DATA = 'UPDATE_SPA_DATA'
export const SIGN_IN = 'SIGN_IN'
export const SIGN_UP = 'SIGN_UP'
export const ACCESS_DATA = 'ACCESS_DATA'

export const SET_MOD_DOWNLOAD_ACCEPTED = 'CURRENT_ACCOUNT_SET_MOD_DOWNLOAD_ACCEPTED'
export const SET_OVERALL_LANGUAGE_FILTER = 'CURRENT_ACCOUNT_SET_OVERALL_LANGUAGE_FILTER'
export const SET_RULES_ACCEPTED = 'CURRENT_ACCOUNT_SET_RULES_ACCEPTED'
export const UPDATE_MODS_COUNT = 'UPDATE_MODS_COUNT'
export const SET_IE_ALERT_ACCEPTED = 'SET_IE_ALERT_ACCEPTED'
export const SET_EDGE_ALERT_ACCEPTED = 'SET_EDGE_ALERT_ACCEPTED'

export const DOWNLOAD_ZIP = 'DOWNLOAD_ZIP'
export const ZIP_IS_READY = 'ZIP_IS_READY'
export const SET_ERROR_DOWNLOAD_ZIP = 'SET_ERROR_DOWNLOAD_ZIP'

export const CHECK_FILE_SIZE = 'CHECK_FILE_SIZE'
export const SET_ERROR_CHECK_FILE_SIZE = 'SET_ERROR_CHECK_FILE_SIZE'

export const startFetching = () => ({
    type: START_FETCHING,
})

export const stopFetching = () => ({
    type: STOP_FETCHING,
})

export const startLogin = () => ({
    type: START_LOGIN,
})

export const stopLogin = () => ({
    type: STOP_LOGIN,
})

export const downloadZip = (rawResponseData, state) => {
    return({ 
    type: DOWNLOAD_ZIP,
    payload: {
        zipOriginalName: rawResponseData.context.zip_original_name,
        zipSize: rawResponseData.context.zip_size,
    },
})}

export const setErrorDownloadZip = (errorData) => ({
    type: SET_ERROR_DOWNLOAD_ZIP,
    payload: {
        errorData,
    },
})

export const checkZipSize = (rawResponseData, state) => {
    return({ 
    type: CHECK_FILE_SIZE,
    payload: {
        zipSize: rawResponseData.context.file_size_from_server,
    },
})}

export const zipIsReady = (rawResponseData, state) => {
    return({ 
    type: ZIP_IS_READY,
    payload: {
        isZipReady: rawResponseData.context.is_zip_ready,
    },
})}

export const setErrorCheckFileSize = (errorData) => ({
    type: SET_ERROR_CHECK_FILE_SIZE,
    payload: {
        errorData,
    },
})

export const updateSpaData = (rawResponseData, state) => {
    return({ 
    type: UPDATE_ACCOUNT, // UPDATE_SPA_DATA
    payload: {
        spaId: rawResponseData.spaId,
        spaUsername: rawResponseData.spaUsername,
    },
})}

export const signIn = (rawResponseData, state) => {
    return({ 
    type: SIGN_IN,
    payload: rawResponseData,
})}

export const signUp = (rawResponseData, state) => {
    return({ 
    type: SIGN_UP,
    payload: rawResponseData,
})}

export const updAccessData = (rawResponseData, state) => {
    return({ 
    type: ACCESS_DATA,
    payload: {
        accessKey: rawResponseData.accessKey,
        accessData: processUpdateAccessData(rawResponseData, state),
    }
})}

export const updateSpaDataWithNotify = (rawResponseData, state) => {
    return({ 
    type: UPDATE_ACCOUNT, // UPDATE_SPA_DATA
    payload: {
        isUserStatisticsSufficient: rawResponseData.isUserStatisticsSufficient, // соответствует ли аккаунт загрузке модов
        count: rawResponseData.notifications.count,
        notifications: processNotifications(rawResponseData.notifications.notes, state),
        spaId: rawResponseData.spaId,
        spaUsername: rawResponseData.spaUsername,
    },
})}

export const toProlongate = (rawResponseData) => {
    return window.location.href = urls.prolongate+'?spa_id='+rawResponseData.spaId+'&spa_username='+rawResponseData.spaUsername+'&access_token='+rawResponseData.access_token+'&expires='+rawResponseData.expires
    //pushProlongateWithData(this.props.history, rawResponseData)
}

export const toSignIn = (rawResponseData) => {
    return window.location.href = urls.signin
    //pushProlongateWithData(this.props.history, rawResponseData)
}

export const logoutUser = () => {
    return window.location.href = urls.logout;
}

export const updateAccount = () => ({
    type: UPDATE_ACCOUNT,
})

export const setLanguage = (code) => ({
    type: SET_LANGUAGE,
    code,
})

export const setRulesAccepted = () => ({
    type: SET_RULES_ACCEPTED,
})

export const setModDownloadAccepted = () => ({
    type: SET_MOD_DOWNLOAD_ACCEPTED,
})

export const setOverallLanguageFilter = (language) => ({
    type: SET_OVERALL_LANGUAGE_FILTER,
    payload: {
        language,
    },
})

export const setIsBanned = () => ({
    type: SET_IS_BANNED,
})

export const updateModsCount = (count) => ({
    type: UPDATE_MODS_COUNT,
    count,
})

export const setErrorLogin = (errorData) => ({
    type: SET_ERROR_LOGIN,
    payload: {
        errorData,
    },
})

export const login = (realm) => {
    return (dispatch) => {
        dispatch(startFetching())
        CommonMenu.login(realm)
    }
}

/* get user data from server lesta id and add it to state */
export const authorization = (rawData) => {
    return (dispatch, getState) => {
        const state = getState();

        const url = `https://tankimods.net`+apiUrls.userNotifications

        //dispatch(startFetching()) //dispatch(startLogin())
        
        if (typeof(rawData.expires) === 'undefined' || rawData.expires === null ) {
            const fetchPromise = dispatch(batchActions([
                updateSpaData(rawData, state),
                //stopFetching(),
            ], UPDATE_ACCOUNT));

            return fetchPromise;
        } else {
            const fetchPromise = fetch(url, {method: 'POST', body: rawData}).promise
                .then((rawResponseData) => {
                    if (rawResponseData.status === 'error') {
                        if (rawResponseData.context.code === 417) {
                            dispatch(batchActions([
                                setErrorLogin(rawResponseData.context),
                                //stopFetching(),
                            ], SET_ERROR_LOGIN))
                        } else {
                            dispatch(batchActions([
                                setErrorLogin(rawResponseData.context),
                                //stopFetching(),
                            ], SET_ERROR_LOGIN))
                        }
                    } else {
                        dispatch(batchActions([
                            updateSpaDataWithNotify(rawResponseData, state),
                            //stopFetching(),
                        ], UPDATE_ACCOUNT))
                    }
                })
                .catch((errorData) => {
                    dispatch(batchActions([
                        setErrorLogin(errorData),
                        //stopFetching(),
                    ], SET_ERROR_LOGIN))
                })
            return fetchWithSpinner(dispatch, fetchPromise); // fetchPromise
        }
        // 
    }
}

/* prolongate user data */
export const prolongate = (rawData) => {
    return (dispatch, getState) => {
        const state = getState();

        const url = `https://tankimods.net`+apiUrls.prolongate
        
        dispatch(startLogin())

        const fetchPromise = fetch(url, {method: 'POST', body: rawData}).promise
            .then((rawResponseData) => {
                if (rawResponseData.status === 'error') {
                    if (rawResponseData.context.code === 417) {
                        dispatch(batchActions([
                            setErrorLogin(rawResponseData.context),
                            logoutUser(),
                            stopLogin(),
                        ], SET_ERROR_LOGIN))
                    } else if (rawResponseData.context.msg === 'RT_JWT_NOT_FOUND_IN_BD') {
                        dispatch(batchActions([
                            setErrorLogin(rawResponseData.context),
                            logoutUser(),
                            stopLogin(),
                        ], SET_ERROR_LOGIN))
                    } else {
                        dispatch(batchActions([
                            setErrorLogin(rawResponseData.context),
                            stopLogin(),
                        ], SET_ERROR_LOGIN))
                    }
                } else {
                    dispatch(batchActions([
                        updateSpaData(rawResponseData, state),
                        toProlongate(rawResponseData),
                        stopLogin(),
                    ], UPDATE_ACCOUNT))
                }
            })
            .catch((errorData) => {
                dispatch(batchActions([
                    setErrorLogin(errorData),
                    stopLogin(),
                ], SET_ERROR_LOGIN))
            })
        return fetchWithSpinner(dispatch, fetchPromise)
    }
}

/* fetching notifications user menu */

export const setIEAlertAccepted = () => ({
    type: SET_IE_ALERT_ACCEPTED,
})

export const setEdgeAlertAccepted = () => ({
    type: SET_EDGE_ALERT_ACCEPTED,
})


/* make zip with chosen mods in basket and then download it */
export const archivator = (basketData) => {
    return (dispatch, getState) => {
        const state = getState();

        const url = `https://tankimods.net`+apiUrls.zipDownload

        //dispatch(startFetching()) //dispatch(startLogin())
        
        const fetchPromise = fetch(url, {method: 'POST', body: basketData}).promise
            .then((rawResponseData) => {
                if (rawResponseData.status === 'error') {
                    dispatch(batchActions([
                        setErrorDownloadZip(rawResponseData.context),
                        //stopFetching(),
                    ], SET_ERROR_DOWNLOAD_ZIP))
                    /*if (rawResponseData.context.code === 417) {
                        dispatch(batchActions([
                            setErrorLogin(rawResponseData.context),
                            //stopFetching(),
                        ], SET_ERROR_LOGIN))
                    } else {
                        dispatch(batchActions([
                            setErrorLogin(rawResponseData.context),
                            //stopFetching(),
                        ], SET_ERROR_LOGIN))
                    }*/
                } else {
                    dispatch(batchActions([
                        downloadZip(rawResponseData, state)
                        //multiDownload(['https://tankimods.net/media/mod_files/'.rawResponseData.context.file_original_name])
                        //stopFetching(),
                    ], DOWNLOAD_ZIP))
                }
            })
            .catch((errorData) => {
                dispatch(batchActions([
                    setErrorDownloadZip(errorData),
                    //stopFetching(),
                ], SET_ERROR_DOWNLOAD_ZIP))
            })
        return fetchWithSpinner(dispatch, fetchPromise); // fetchPromise
        // 
    }
}

export const checkFileSize = (data) => {
    return (dispatch, getState) => {
        const state = getState();

        const url = `https://tankimods.net/api/zipp/checkSize.php`//+apiUrls.zipDownload

        //dispatch(startFetching()) //dispatch(startLogin())
        
        const fetchPromise = fetch(url, {method: 'POST', body: data}).promise
            .then((rawResponseData) => {
                if (rawResponseData.status === 'error') {
                    dispatch(batchActions([
                        setErrorCheckFileSize(rawResponseData.context),
                    ], SET_ERROR_CHECK_FILE_SIZE))
                } else {
                    if (rawResponseData.context.msg === 'zipp_file_size_is_false') {
                        dispatch(batchActions([
                            checkZipSize(rawResponseData, state)
                        ], CHECK_FILE_SIZE))
                    } else {
                        dispatch(batchActions([
                            zipIsReady(rawResponseData, state)
                        ], ZIP_IS_READY))
                    }
                }
            })
            .catch((errorData) => {
                dispatch(batchActions([
                    setErrorCheckFileSize(errorData),
                ], SET_ERROR_CHECK_FILE_SIZE))
            })
        return fetchPromise;//fetchWithSpinner(dispatch, fetchPromise); // fetchPromise
        // 
    }
}



/* notifications */